export default "__VITE_ASSET__DLFDChul__"